import { styled } from '@mui/system';
import { Pagination, TableCell } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  margin: theme.spacing(3, 3, 3, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(3, 1, 3, 1),
    padding: 0
  },
  [theme.breakpoints.down('sm')]: {
    margin: 0
  }
}));

export const TitleBodyCell = styled(TableCell)(() => ({
  maxWidth: 200
}));

export const DescriptionBodyCell = styled(TableCell)(({ theme }) => ({
  padding: `${theme.spacing(0.5, 3, 2, 0)} !important`
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  minWidth: 155,
  whiteSpace: 'pre'
}));

export const AddButtonArea = styled('div')(() => ({
  gridArea: 'addBtn',
  justifySelf: 'end'
}));

export const AddButtonLabel = styled('span')(() => ({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: 4
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2)
  },
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const PaginationPlaceholder = styled('div')(() => ({
  height: 1
}));

export const MobileCardContainer = styled('div')(() => ({
  margin: '16px 10px 10px 10px'
}));

export const MobilePaginationContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    paddingBottom: '80px'
  }
}));

export const ProjectTitleText = styled('span')(() => ({
  maxWidth: 150,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word'
}));
